import { useCallback, useRef } from 'react';
import moment from 'moment';
import { LoadingOutlined, PauseOutlined, CaretRightOutlined, RetweetOutlined } from '@ant-design/icons';
import { Slider, Tooltip } from 'antd';
import styled from 'styled-components';
import VolumeInput from './audio-volume-input.component';
import { styleVariables } from '../../style';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledContainer = styled.div.withConfig({
  displayName: "responder-audio-playercomponent__StyledContainer",
  componentId: "sc-1uc7lwi-0"
})(["display:flex;align-items:center;padding:10px 14px;margin-top:20px;height:50px;background-color:", ";border-radius:30px;"], styleVariables.colors.gray3);
var StyledDuration = styled.div.withConfig({
  displayName: "responder-audio-playercomponent__StyledDuration",
  componentId: "sc-1uc7lwi-1"
})(["margin-right:14px;"]);
var StyledProgressBar = styled(Slider).withConfig({
  displayName: "responder-audio-playercomponent__StyledProgressBar",
  componentId: "sc-1uc7lwi-2"
})(["width:100%;flex:1;margin-right:14px;"]);
var StyledLoadingOutlined = styled(LoadingOutlined).withConfig({
  displayName: "responder-audio-playercomponent__StyledLoadingOutlined",
  componentId: "sc-1uc7lwi-3"
})(["font-size:18px;margin-right:14px;"]);
var StyledPauseOutlined = styled(PauseOutlined).withConfig({
  displayName: "responder-audio-playercomponent__StyledPauseOutlined",
  componentId: "sc-1uc7lwi-4"
})(["font-size:18px;margin-right:14px;color:", ";"], function (_ref) {
  var isAllowToPause = _ref.isAllowToPause;
  return isAllowToPause ? styleVariables.colors.gray13 : styleVariables.colors.gray10;
});
var StyledCaretRightOutlined = styled(CaretRightOutlined).withConfig({
  displayName: "responder-audio-playercomponent__StyledCaretRightOutlined",
  componentId: "sc-1uc7lwi-5"
})(["font-size:18px;margin-right:14px;"]);
var StyledReplayButton = styled.div.withConfig({
  displayName: "responder-audio-playercomponent__StyledReplayButton",
  componentId: "sc-1uc7lwi-6"
})(["margin-right:14px;position:relative;cursor:pointer;"]);
var StyledRetweetOutlined = styled(RetweetOutlined).withConfig({
  displayName: "responder-audio-playercomponent__StyledRetweetOutlined",
  componentId: "sc-1uc7lwi-7"
})(["font-size:18px;"]);
var StyledReplayCount = styled.div.withConfig({
  displayName: "responder-audio-playercomponent__StyledReplayCount",
  componentId: "sc-1uc7lwi-8"
})(["position:absolute;right:-3px;top:-3px;padding:1px;width:15px;height:15px;display:flex;justify-content:center;align-items:center;border-radius:50%;font-size:10px;color:", ";background-color:", ";"], styleVariables.colors.gray1, styleVariables.colors.gray13);
export var ResponderAudioPlayer = function ResponderAudioPlayer(_ref2) {
  var isLoading = _ref2.isLoading,
      isPlaying = _ref2.isPlaying,
      _ref2$numberOfReplays = _ref2.numberOfReplays,
      numberOfReplays = _ref2$numberOfReplays === void 0 ? 0 : _ref2$numberOfReplays,
      duration = _ref2.duration,
      volume = _ref2.volume,
      onPlay = _ref2.onPlay,
      onReplay = _ref2.onReplay,
      onPause = _ref2.onPause,
      onVolumeChange = _ref2.onVolumeChange,
      toggleMute = _ref2.toggleMute,
      progress = _ref2.progress,
      currentTime = _ref2.currentTime,
      isAllowToPause = _ref2.isAllowToPause,
      label = _ref2.label;
  var audioRef = useRef(null); // render

  var renderPlayButton = function renderPlayButton() {
    if (isPlaying) {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: isAllowToPause ? '' : label === null || label === void 0 ? void 0 : label.notAllowToPause,
        children: /*#__PURE__*/_jsx(StyledPauseOutlined, {
          isAllowToPause: isAllowToPause,
          onClick: onPause
        })
      });
    }

    if (isLoading) {
      return /*#__PURE__*/_jsx(StyledLoadingOutlined, {});
    }

    return /*#__PURE__*/_jsx(StyledCaretRightOutlined, {
      onClick: onPlay
    });
  };

  var renderTime = function renderTime(time) {
    var momentDuration = moment.duration(time, 'seconds');
    return "".concat(momentDuration.minutes().toString().padStart(2, '0'), ":").concat(momentDuration.seconds().toString().padStart(2, '0'));
  };

  var renderReplayButton = useCallback(function () {
    if (numberOfReplays === 0) return;
    if (!numberOfReplays) return;
    return /*#__PURE__*/_jsxs(StyledReplayButton, {
      onClick: onReplay,
      children: [/*#__PURE__*/_jsx(StyledRetweetOutlined, {
        disabled: numberOfReplays === 0
      }), /*#__PURE__*/_jsx(StyledReplayCount, {
        children: numberOfReplays
      })]
    });
  }, [audioRef, numberOfReplays]);

  var formatProgress = function formatProgress(value) {
    var currentTime = value / 100 * duration;
    return renderTime(currentTime);
  };

  return /*#__PURE__*/_jsxs(StyledContainer, {
    children: [renderPlayButton(), /*#__PURE__*/_jsxs(StyledDuration, {
      children: [renderTime(currentTime), " / ", renderTime(duration)]
    }), /*#__PURE__*/_jsx(StyledProgressBar, {
      value: progress,
      tooltip: {
        formatter: formatProgress
      },
      trackStyle: {
        backgroundColor: '#000'
      },
      handleStyle: {
        borderColor: '#000'
      }
    }), renderReplayButton(), /*#__PURE__*/_jsx(VolumeInput, {
      volume: volume,
      onVolumeChange: onVolumeChange,
      onToggleMute: toggleMute
    })]
  });
};